import clsx from 'clsx';
import { useIconStyle } from '../../components/commons';
import { IconProps } from '../../components/Icons';

function DownIcon({ className = '', style }: IconProps) {
  const classes = useIconStyle();

  return (
    <svg
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={clsx(classes.root, {
        [className]: className.length > 0,
      })}
      style={style}
    >
      <path
        d='M0.86477 3.65803C0.675905 3.45657 0.359487 3.44637 0.158031 3.63523C-0.0434251 3.8241 -0.0536321 4.14052 0.135233 4.34197L7.63523 12.342C7.83277 12.5527 8.16723 12.5527 8.36477 12.342L15.8648 4.34197C16.0536 4.14052 16.0434 3.8241 15.842 3.63523C15.6405 3.44637 15.3241 3.45657 15.1352 3.65803L8 11.2689L0.86477 3.65803Z'
        fill='currentColor'
      />
    </svg>
  );
}

export default DownIcon;
